module.exports = __webpack_public_path__ + "static/media/indexRight.2b8fa6d2.svg";